<template>
  <div class="container">
    <h1>{{ $t('common.lbl.error_code_404')}}</h1>
    <p>
      <strong>{{ $t('common.msg.not_found_page') }}</strong>
    </p>
    <!-- <p>
      <a href="/" class="px-2">{{ $t('common.lbl.back')}}</a>
      <a href="/" class="px-2">{{ $t('common.lbl.home')}}</a>
    </p> -->
    <a href="/" class="logo logo-img-1x">
      <!-- <img width="200" title alt :src="appLogo" /> -->
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      appLogo: require(`@/redworks/assets/logo.png`),
    };
  },
};
</script>

<style scoped>
.container {
  margin: 50px auto 40px auto;
  width: 600px;
  text-align: center;
}

a {
  color: #4183c4;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}

h1 {
  width: 800px;
  position: relative;
  left: -100px;
  letter-spacing: -1px;
  line-height: 60px;
  font-size: 60px;
  font-weight: 100;
  margin: 0px 0 50px 0;
  text-shadow: 0 1px 0 #fff;
}
p {
  color: rgba(0, 0, 0, 0.5);
  margin: 20px 0;
  line-height: 1.6;
}


.logo {
  display: inline-block;
  margin-top: 35px;
}
</style>
